// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { type BannerProps } from './Banner'

interface SiteBanners {
  products: BannerProps
  support: BannerProps
  pricing: BannerProps
  solutionsEnterprise: BannerProps
  solutionsDevelopers: BannerProps
  solutionsStartups: BannerProps
}

const Banners: SiteBanners = {
  products: {
    title: 'Products',
    text: (
      <>
        On-demand, testable and customizable <br /> infrastructure for AI training,
        <br />
        fine-tuning & inference
      </>
    ),
    actions: [
      {
        label: 'Sign up',
        redirectTo: process.env.CONSOLE_URL ?? ''
      },
      {
        label: 'Contact Sales',
        redirectTo: process.env.CONTACT_SALES_URL ?? '',
        openInNewTab: true,
        variant: 'outline-secondary'
      }
    ],
    customClass: 'products'
  },
  support: {
    title: 'Technical support',
    text: (
      <>
        Connect with us, engage with our resources and get
        <br /> self-service help for Intel Tiber AI Cloud services.
      </>
    ),
    customClass: 'support'
  },
  pricing: {
    title: 'Pricing',
    text: (
      <>
        Rates for GPUs and AI processors running
        <br />
        on bare metal or virtual machines.
      </>
    ),
    actions: [
      {
        label: 'Sign up',
        redirectTo: process.env.CONSOLE_URL ?? ''
      },
      {
        label: 'Contact Sales',
        redirectTo: process.env.CONTACT_SALES_URL ?? '',
        openInNewTab: true,
        variant: 'outline-secondary'
      }
    ],
    customClass: 'pricing'
  },
  solutionsEnterprise: {
    title: 'Scale with confidence while reducing costs',
    text: (
      <>
        Our scalable cloud platform ensures you
        <br />
        always have the resources you need to
        <br />
        handle your growing AI workloads
      </>
    ),
    actions: [
      {
        label: 'Sign up',
        redirectTo: process.env.CONSOLE_URL ?? ''
      },
      {
        label: 'Contact Sales',
        redirectTo: process.env.CONTACT_SALES_URL ?? '',
        openInNewTab: true,
        variant: 'outline-secondary'
      }
    ],
    customClass: 'solutionsEnterprise pt-s11'
  },
  solutionsDevelopers: {
    title: 'Developers',
    text: (
      <>
        Find the resources to go from 0 to 100 in our cloud.
        <br />
        It’s easy to change to the Intel stack.
      </>
    ),
    actions: [
      {
        label: 'Sign up',
        redirectTo: process.env.CONSOLE_URL ?? ''
      },
      {
        label: 'Contact Sales',
        redirectTo: process.env.CONTACT_SALES_URL ?? '',
        openInNewTab: true,
        variant: 'outline-secondary'
      }
    ],
    customClass: 'solutionsDevelopers'
  },
  solutionsStartups: {
    title: 'Intel® Liftoff',
    text: (
      <>
        AI Startup Accelerator
        <br />
        on Intel® Tiber™ AI Cloud
      </>
    ),
    actions: [
      {
        label: 'Apply now!',
        redirectTo: process.env.STARTUP_APPLY_URL ?? ''
      }
    ],
    customClass: 'solutionsStartups'
  }
}

export default Banners
